import React from 'react'
import { v4 } from 'uuid'
import queryString from 'query-string'
import { ThemeProvider } from 'styled-components'
import Routes from './routes'
import AccountProvider from './providers/accountProvider'
import ControlsProvider from './providers/controlsProvider'
import NotificationsProvider from './providers/notificationsProvider'
import { theme } from './designSystem'
import './App.css'
import { withRouter } from 'react-router-dom'

const handleNativePageLoad = (showPopup = true, initial_page) => {
  if (window.Android) {
    if (window.Android.onPageLoaded) {
      console.log('Executed onPageLoaded')
      window.Android.onPageLoaded(showPopup, 'onboarding')
    }
  } else {
    console.log('Function onPageLoaded not exist')
  }
  if (window.webkit) {
    if (window.webkit.messageHandlers) {
      console.log('onPageLoaded webkit.messageHandlers')
      window.webkit.messageHandlers.onPageLoaded.postMessage({
        exit_confirmation: showPopup,
        initial_page_host: 'onboarding',
      })
    }
  }
}

class App extends React.Component {
  componentDidMount() {
    const { history } = this.props

    history.listen((location) => {
      const { pathname } = location
      if (
        pathname.includes('edit-profile') ||
        pathname.includes('edit-novel-details') ||
        pathname.includes('add-chapter') ||
        pathname.includes('edit-chapter')
      ) {
        handleNativePageLoad(true)
      } else handleNativePageLoad(false)
    })
    const { referrer, origin, app_version, medium, campaign } =
      queryString.parse(
        window.parent ? window.parent.location.search : window.location.search
      )
    if (medium) {
      sessionStorage.setItem('medium', medium)
    }
    if (campaign) {
      sessionStorage.setItem('campaign', campaign)
    }
    if (!referrer) {
      document.referrer.includes('google')
        ? localStorage.setItem('referrer', 'google')
        : localStorage.setItem('referrer', 'url')
    } else {
      localStorage.setItem('referrer', referrer)
    }
    if (!localStorage.getItem('uuid')) {
      const id = v4().split('-').join('')
      localStorage.setItem('uuid', id)
    }
    if (origin) {
      localStorage.setItem('app_origin', origin)
    }
    if (app_version) {
      localStorage.setItem('native_app_version', app_version)
    }
    // if (window.fcWidget) {
    //   window.fcWidget.init({
    //     token: '77c39ffd-cd0c-4e39-82c0-4f9681053b4e',
    //     host: 'https://wchat.in.freshchat.com',
    //     tags: ['writers'],
    //   })
    // }
    localStorage.removeItem('writer_notifications')
  }

  render() {
    return (
      <ThemeProvider theme={theme.light}>
        <AccountProvider>
          <ControlsProvider>
            <NotificationsProvider>
              <Routes />
            </NotificationsProvider>
          </ControlsProvider>
        </AccountProvider>
      </ThemeProvider>
    )
  }
}

export default withRouter(App)
